import React, { useEffect } from 'react';
import Hero from './Hero';
import KeyMetrics from './KeyMetrics';
import Features from './Features';
import ModuleCards from './ModuleCards';
import ProcessTimeline from './ProcessTimeline';
import CTABanner from './CTABanner';
import Footer from '../../Footer';

const SchoolManagementPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div style={{ fontFamily: "'Montserrat', Helvetica, Arial, sans-serif" }}>
      <Hero />
      <KeyMetrics />
      <Features />
      <ModuleCards />
      <ProcessTimeline />
      <CTABanner />
      <Footer />
    </div>
  );
}

export default SchoolManagementPage;
